import { useState } from 'react';
import GoogleIcon from '@mui/icons-material/Google';
import { Button } from '@mui/material';

import { idpApi } from '../services/idp-api';

type GoogleSignInButtonProps = {
  flowId: string;
  label: string;
};

export function GoogleSignInButton({ flowId, label }: GoogleSignInButtonProps) {
  const [isPending, setIsPending] = useState(false);

  async function handleGoogleSignIn() {
    if (flowId === '' || isPending) return;
    setIsPending(true);
    try {
      const { authorizeUrl } = await idpApi.googleInitiate(flowId);
      window.location.assign(authorizeUrl);
    } catch {
      setIsPending(false);
    }
  }

  return (
    <Button
      type="button"
      variant="outlined"
      color="inherit"
      startIcon={<GoogleIcon />}
      onClick={() => void handleGoogleSignIn()}
      disabled={flowId === '' || isPending}
      fullWidth
    >
      {isPending ? 'Redirecting…' : label}
    </Button>
  );
}
